exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-active-generate-id {\n\tbackground-color: #00a09c !important;\n}\n.carbon-item {\n\ttransition: all 200ms ease-in-out;\n}\n", ""]);

// exports
